define([
	"dojo/_base/declare",
	"csi/heading/AttributeAction",
	"csi/xml"
], function(declare,AttributeAction,xml) {

	return declare(AttributeAction, {
		constructor: function(def) {
			this.m_id = "BrowseImage";
			this.m_right = xml.RIGHT_WRITE;
			this.classController = "csi.heading.RefImageBrowseController";
		}
	});
});